import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import Loading from '../shared/components/Loading';
import { reduceVisualPersonalizationData } from '../shared/utils/common';

const PDP = Loadable({
  loader: () => import('../pdp/components/VisualPersonalizationPdp' /* webpackChunkName: 'vppdp' */),
  loading: () => {
    return <Loading spinnerSrc={window.imageAssets.loading} />;
  },
})

const pdpVisualPersonalizationID = 'pdp-vp';
const myFitCookieID = '_tl_ff_my_fit';
const utmTermCookieID = '_tl_utm_term';

const renderPdpVp = (attachToElement, myFit, shouldRenderBreastShapes) => {
  const productStyle = attachToElement.getAttribute('data-product-style');
  const productCupStyle = attachToElement.getAttribute('data-cup-style');
  const breastShapeOrder = attachToElement.getAttribute('data-breast-shape-order');
  const size = myFit ? myFit.result_size : undefined;
  const currentState = {
    size,
    currentStyle: productStyle,
    visualPersonalizationDataByStyle: window.visualPersonalizationDataByStyle,
  };
  const dataLabel = myFit ? `PDP_VP_${productStyle}_${myFit.breast_shape}_${myFit.bra_style}` : `PDP_VP_${productStyle}`;
  const currentBreastShape = myFit ? myFit.breast_shape : undefined;
  const recommendedStyle = myFit ? myFit.bra_style : undefined;
  const pdpVp = <PDP
    shouldRenderBreastShapes={shouldRenderBreastShapes}
    breastShapes={window.TL_BREAST_SHAPES}
    breastShapeOrder={breastShapeOrder ? breastShapeOrder.split(',') : undefined}
    currentBreastShape={currentBreastShape}
    dataLabel={dataLabel}
    featuresData={reduceVisualPersonalizationData(myFit, currentState).featuresData || []}
    iconSrcBra={window.imageAssets['icon-ff-bra']}
    iconSrcRuler={window.imageAssets['icon-ff-ruler']}
    productCupStyle={productCupStyle}
    recommendedStyle={recommendedStyle}
    size={size}
  />;

  ReactDOM.render(pdpVp, attachToElement);
};

window.PdpBootstrap = {
  attachElement: function(component) {
    const attachToElement = document.getElementById(pdpVisualPersonalizationID);
    let shouldRenderBreastShape = true;
    if (typeof attachToElement !== 'undefined' && attachToElement !== null) {
      if (window.ParseInitialized && window.Cookies) {
        const utmTermCookie = Cookies.get(utmTermCookieID);
        if (utmTermCookie) {
          shouldRenderBreastShape = !utmTermCookie.toLowerCase().includes('hbs-');
        }
        if (Cookies.get(myFitCookieID)) {
          Parse.Cloud.run('getFitFinderData', { objectId: Cookies.get(myFitCookieID) })
          .then(function (response) {
            const myFit = response.data;
            renderPdpVp(attachToElement, myFit, shouldRenderBreastShape);
          }, function (error) {
            console.error("Error getting FF data: ", error);
            // render default visual personalization module
            renderPdpVp(attachToElement, null, shouldRenderBreastShape);
          })
        } else {   
          renderPdpVp(attachToElement, null, shouldRenderBreastShape);
        }
      } else {
        const queryParam = window.getParameterByNameCaseInsensitive('utm_term');
        if (queryParam) {
          shouldRenderBreastShape = !queryParam.toLowerCase().includes('hbs-');
        }
        window.setTimeout(window.PdpBootstrap.attachElement, 500)
      }
    };
  },

  initialize: function() {
    window.addEventListener('load', function () {
      window.PdpBootstrap.attachElement();
    });
  },
}

window.PdpBootstrap.initialize();



// WEBPACK FOOTER //
// ./src/reactjs/pdp/PDPBootstrap.js